import { Pipe } from '@angular/core';
import {Utils} from "@app/utilities/Utils";

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe {
  transform(array: any[] = [], field: string): any[] {
    if (!Array.isArray(array)) return [];

    return Utils.orderBy(array, field);
  }
}
